const initialState = {
	SummaryItems: [],
    timeoff_type: null,  
    unavailableDate: [],
    accuredProjections: [],
    timeOffResponse: null,
    MUItems: [],
    TimeOffEnumItems: [],
    RequestStatusEnumItems: [],
    ptoSpots: [],
    CurrentRequests: [],
    FilteredRequests: []
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/timeoff/redux/initialState.js